import { memo, useCallback } from "react";

import { CommandPaletteBucket, CommandPaletteAction } from "components/CommandPalette/types";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import { BUCKET_IDS } from "components/CommandPalette/constants";
import useCommandPaletteRecentActionsStore from "components/CommandPalette/store/useRecentActionsStore";

import CommandPaletteActionItem from "../ActionItem";

type CommandPaletteBucketItemProps = {
  bucket: CommandPaletteBucket;
  actions: CommandPaletteAction[];
  activeActionId: string | undefined;
};

const CommandPaletteBucketItem = ({
  bucket,
  actions,
  activeActionId,
}: CommandPaletteBucketItemProps) => {
  const removeAction = useCommandPaletteRecentActionsStore((state) => state.removeAction);
  const isRecentBucket = bucket.id === BUCKET_IDS.RECENT_ACTIONS;

  const handleRemove = useCallback(
    (actionId: string) => {
      removeAction(actionId);
    },
    [removeAction]
  );

  return (
    <Box direction="column" gap="small">
      <Typography
        variant="p-t8"
        tag="span"
        transform="uppercase"
        color="secondary"
        margin="0 0 small"
      >
        {bucket.title}
      </Typography>

      {actions.map((action) => (
        <CommandPaletteActionItem
          key={action.id}
          action={action}
          isActive={action.id === activeActionId}
          onRemove={isRecentBucket ? () => handleRemove(action.id) : undefined}
        />
      ))}
    </Box>
  );
};

export default memo(CommandPaletteBucketItem);
